import React from 'react';
import {
  IonModal,
  IonButton,
  IonContent,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonGrid,
  IonRow,
  IonCol,
  IonText
} from '@ionic/react';
import JobTimeline from 'src/components/JobTimeline';
import { secondsToTime, formatDate, add } from 'src/lib/time';

export default class DetailsModal extends React.Component {
  render() {
    const { isOpen, onClose, job } = this.props;
    return (
      <React.Fragment>
        <IonModal isOpen={isOpen}>
          <IonHeader translucent>
            <IonToolbar>
              <IonTitle>Job Details</IonTitle>
              <IonButtons slot="end">
                <IonButton onclick={onClose && onClose}>Close</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonGrid fluid>
              <IonRow className="ion-margin-bottom">
                <IonCol size={6}>
                  <p className="lead mb-1">Job #: {job.ref_id || 'NA'}</p>
                  <p className="lead mb-1">{job.customer.full_name}</p>
                  <a
                    className="lead mb-1"
                    href={`tel:${job.customer.phone.replace(/[- )(]/g, '')}`}
                  >
                    {job.customer.phone}
                  </a>
                </IonCol>
                <IonCol size={6} className="ion-text-right">
                  <p className="lead mb-1">
                    Status:{' '}
                    <span className="text-primary">
                      {job.status.charAt(0).toUpperCase() + job.status.slice(1)}
                    </span>
                  </p>
                  {job.start_time && (
                    <p className="lead mb-1">
                      ETA:{' '}
                      {formatDate(
                        add(job.start_time, job.adjusted_estimate, 'seconds'),
                        'time'
                      )}
                    </p>
                  )}
                </IonCol>
              </IonRow>
            </IonGrid>
            <div
              className="details p-4 ion-text-center"
              style={{
                borderTop: '1px solid #ddd',
                borderBottom: '1px solid #ddd'
              }}
            >
              <h1 className="mt-0 strong">
                {formatDate(job.scheduled_time, 'date')}
              </h1>
              <h3 className="mt-0">{`${formatDate(
                job.scheduled_time,
                'time'
              )} - ${formatDate(
                add(job.scheduled_time, job.original_estimate, 'seconds'),
                'time'
              )}`}</h3>
              <IonText color="medium">
                <h4>{secondsToTime(job.original_estimate)} estimated time</h4>
              </IonText>
              <p className="mb-0">{job.description}</p>
            </div>
            <div className="my-3">
              <JobTimeline job={job} disabled />
            </div>
            <IonGrid
              fluid
              style={{ borderTop: '1px solid #ddd' }}
              className="ion-padding"
            >
              {this.props.job.stages
                .filter((stage) => stage.type === 'travel')
                .map((stage, index) => {
                  return (
                    <div key={index} style={{ width: '100%' }}>
                      <p className="strong mb-3">
                        {secondsToTime(stage.original_estimate)} travel time
                      </p>
                      <div className="d-flex mb-3">
                        <div>
                          <span className="dot success mr-3" />
                        </div>
                        <div>
                          <p className="mb-0">{stage.origin_address}</p>
                          {stage.origin_suite && (
                            <p className="mb-0">
                              Apt/Suite: {stage.origin_suite}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div>
                          <span className="dot danger mr-3" />
                        </div>
                        <div>
                          <p className="mb-0">{stage.destination_address}</p>
                          {stage.destination_suite && (
                            <p className="mb-0">
                              Apt/Suite: {stage.destination_suite}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </IonGrid>
          </IonContent>
        </IonModal>
      </React.Fragment>
    );
  }
}
